module.exports = __webpack_public_path__ + "static/media/down-chevron.70942e8a.svg";